import { Message, useMessage } from '@messageformat/react';
import { ReactElement } from 'react';
import { LogoOPMark } from '@op/opds.opux-logo/op';
import { List, ListItem } from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import DisclaimerBox from './DisclaimerBox';
import FullWidthHighlightSection from './FullWidthHighlightSection';

interface Props {
  course: number;
}

const CourseLinkBox = (props: Props): ReactElement => {
  const { course } = props;
  const linksMessageId = `linkBoxLinks.course${course}.links`;
  const linksTitleMessageId = `linkBoxLinks.course${course}.linkBoxTitle`;
  const linksArray = useMessage(linksMessageId);

  return (
    <FullWidthHighlightSection isFooter>
      <LogoOPMark style={{ marginBottom: space.default }} />
      <h2 className="opds-styles-v1-text-title-medium">
        <Message id={linksTitleMessageId} />
      </h2>
      <List style={{ width: '100%' }}>
        {Object.keys(linksArray).map((value, index) => {
          return (
            <ListItem external href={linksArray[value].url()} key={value[0]}>
              <Message id={`${linksMessageId}.${index}.title`} />
            </ListItem>
          );
        })}
      </List>
      <DisclaimerBox />
    </FullWidthHighlightSection>
  );
};

export default CourseLinkBox;
